import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

import { BsBatteryFull } from "react-icons/bs";
import { GiFarmer } from "react-icons/gi";
import { TbPlant } from "react-icons/tb";

import { RiRobot2Fill } from "react-icons/ri";
import {
  MdSensors,
  MdBarChart,
  MdSecurity,
  MdOutlineRemoteControl,
} from "react-icons/md";
import { GiWheat } from "react-icons/gi";
import { TbTargetArrow } from "react-icons/tb";
import { BsCurrencyDollar } from "react-icons/bs";
import { FaBrain } from "react-icons/fa";

import { MdPrecisionManufacturing } from "react-icons/md";
import { GiTreeGrowth } from "react-icons/gi";
import { MdOutlineDashboard } from "react-icons/md";
import { MdTrendingDown } from "react-icons/md";
import { AiOutlineRise } from "react-icons/ai";
function Stat({ value, label }) {
  return (
    <div className="hero__stat">
      <span className="hero__stat-value">{value}</span>
      <span className="hero__stat-label">{label}</span>
    </div>
  );
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div className="feature-card">
      <div className="feature-card__icon">{icon}</div>
      <h3 className="feature-card__title">{title}</h3>
      <p className="feature-card__desc">{desc}</p>
    </div>
  );
}

function SolutionCard({ number, title, desc, tag }) {
  return (
    <div className="solution-card">
      <div className="solution-card__number">{number}</div>
      <span className="solution-card__tag">{tag}</span>
      <h3 className="solution-card__title">{title}</h3>
      <p className="solution-card__desc">{desc}</p>
      <Link to="/projects" className="solution-card__link">
        Detayları Gör
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      </Link>
    </div>
  );
}

export default function Home() {
  const features = [
    {
      icon: <RiRobot2Fill size={32} style={{ color: "var(--clr-primary)" }} />,
      title: "Otonom ve Sürekli Operasyon",
      desc: "Robotlarımız sahada insan müdahalesine ihtiyaç duymadan çalışır, operasyonları kesintisiz hale getirir.",
    },
    {
      icon: (
        <MdPrecisionManufacturing
          size={32}
          style={{ color: "var(--clr-primary)" }}
        />
      ),
      title: "Hassas ve Verimli Uygulama",
      desc: "Sadece gerekli bölgelere müdahale ederek ilaç, su ve enerji kullanımını minimize eder.",
    },
    {
      icon: <GiTreeGrowth size={32} style={{ color: "var(--clr-primary)" }} />,
      title: "Veri Odaklı Karar Mekanizması",
      desc: "Her ağacı ayrı analiz ederek sezgisel değil, veriye dayalı kararlar alınmasını sağlıyoruz.",
    },
    {
      icon: (
        <MdOutlineDashboard size={32} style={{ color: "var(--clr-primary)" }} />
      ),
      title: "Kolay Kullanım ve Uzaktan Yönetim",
      desc: "Tek bir panel üzerinden tüm bahçeyi planlayabilir, izleyebilir ve yönetebilirsiniz.",
    },
    {
      icon: (
        <MdTrendingDown size={32} style={{ color: "var(--clr-primary)" }} />
      ),
      title: "Maliyetleri Düşüren Sistem",
      desc: "İş gücü ihtiyacını azaltır, kaynak kullanımını optimize eder ve toplam operasyon maliyetini düşürür.",
    },
    {
      icon: <AiOutlineRise size={32} style={{ color: "var(--clr-primary)" }} />,
      title: "Yapay Zeka ile Sürekli Gelişim",
      desc: "Toplanan verilerle sistem sürekli öğrenir ve her sezon daha iyi sonuçlar üretir.",
    },
  ];

  const solutions = [
    {
      number: "01",
      tag: "Robotik Platform",
      title: "Otonom Tarım Robotları",
      desc: "Meyve bahçelerinde ağaç sıraları arasında otonom hareket eden, ilaçlama ve saha operasyonlarını gerçekleştiren akıllı robot platformu.",
    },
    {
      number: "02",
      tag: "Yapay Zeka ve Analiz",
      title: "Bitki Sağlığı ve Veri Analizi",
      desc: "Toplanan verilerle bitki sağlığını analiz eden, hastalık risklerini belirleyen ve her ağaç için akıllı kararlar üreten yapay zeka sistemi.",
    },
    {
      number: "03",
      tag: "Dijital Bahçe Platform",
      title: "Bahçe Haritalama ve Yönetim",
      desc: "Bahçenin dijital haritasını oluşturan, operasyonları planlayan ve tüm süreci tek panel üzerinden yönetmeyi sağlayan kontrol sistemi.",
    },
  ];

  return (
    <div className="home page-enter">
      <section className="hero">
        <div className="hero__bg-pattern" aria-hidden="true" />
        <div className="container hero__inner">
          <div className="hero__content">
            <span className="section-label">
              {" "}
              <GiFarmer
                size={14}
                style={{ color: "var(--clr-primary)" }}
              />{" "}
              AgrıTech Girişimi
            </span>
            <h1 className="hero__title">
              <br />
              Yapay Zeka ile Bahçenizi{" "}
              <span className="hero__title-accent">Otonom </span>Yönetin
            </h1>
            <p className="hero__subtitle">
              Vincora, meyve bahçelerinde veri toplar, analiz eder ve otonom
              robotlarla aksiyona dönüştürür.
            </p>
            <div className="hero__actions">
              <Link to="/projects" className="btn btn-primary">
                Projelerimizi Keşfet
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                İletişime Geç
              </Link>
            </div>
            <div className="hero__stats">
              <Stat value="MVP" label="Geliştirme Sürecinde" />
              <div className="hero__stat-divider" />
              <Stat value="%30" label="’a kadar Verim Artışı" />
              <div className="hero__stat-divider" />
              <Stat value="7/24" label="Otonom Operasyon" />
            </div>
          </div>

          <div className="hero__visual" aria-hidden="true">
            <div className="hero__visual-card hero__visual-card--main">
              <div className="hero__visual-robot">
                <svg
                  viewBox="0 0 200 200"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="60"
                    y="80"
                    width="80"
                    height="70"
                    rx="12"
                    fill="var(--clr-primary)"
                    opacity="0.9"
                  />
                  <rect
                    x="70"
                    y="50"
                    width="60"
                    height="40"
                    rx="8"
                    fill="var(--clr-primary-light)"
                  />
                  <circle cx="85" cy="68" r="7" fill="white" />
                  <circle cx="115" cy="68" r="7" fill="white" />
                  <circle cx="85" cy="68" r="4" fill="var(--clr-accent)" />
                  <circle cx="115" cy="68" r="4" fill="var(--clr-accent)" />
                  <line
                    x1="100"
                    y1="50"
                    x2="100"
                    y2="30"
                    stroke="var(--clr-accent)"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <circle cx="100" cy="26" r="5" fill="var(--clr-accent)" />
                  <rect
                    x="30"
                    y="90"
                    width="30"
                    height="14"
                    rx="7"
                    fill="var(--clr-primary-light)"
                  />
                  <rect
                    x="140"
                    y="90"
                    width="30"
                    height="14"
                    rx="7"
                    fill="var(--clr-primary-light)"
                  />
                  <rect
                    x="75"
                    y="95"
                    width="50"
                    height="30"
                    rx="6"
                    fill="rgba(255,255,255,0.15)"
                  />
                  <circle
                    cx="90"
                    cy="110"
                    r="5"
                    fill="var(--clr-accent)"
                    opacity="0.8"
                  />
                  <rect
                    x="100"
                    y="106"
                    width="20"
                    height="3"
                    rx="1.5"
                    fill="rgba(255,255,255,0.5)"
                  />
                  <rect
                    x="100"
                    y="112"
                    width="14"
                    height="3"
                    rx="1.5"
                    fill="rgba(255,255,255,0.3)"
                  />
                  <circle
                    cx="75"
                    cy="158"
                    r="14"
                    fill="var(--clr-primary-dark)"
                  />
                  <circle
                    cx="75"
                    cy="158"
                    r="7"
                    fill="var(--clr-accent)"
                    opacity="0.6"
                  />
                  <circle
                    cx="125"
                    cy="158"
                    r="14"
                    fill="var(--clr-primary-dark)"
                  />
                  <circle
                    cx="125"
                    cy="158"
                    r="7"
                    fill="var(--clr-accent)"
                    opacity="0.6"
                  />
                  <path
                    d="M20 175 Q100 165 180 175 L180 190 L20 190Z"
                    fill="var(--clr-accent)"
                    opacity="0.2"
                  />
                </svg>
              </div>
              <div className="hero__visual-badge">
                <span className="hero__visual-dot" />
                Otonom Mod Aktif
              </div>
            </div>
            <div className="hero__visual-card hero__visual-card--stat">
              <div className="hero__vc-label">Bugünkü Tarama</div>
              <div className="hero__vc-value">12.4 ha</div>
              <div className="hero__vc-bar">
                <div className="hero__vc-fill" />
              </div>
            </div>
            <div className="hero__visual-card hero__visual-card--alert">
              <TbPlant size={20} style={{ color: "var(--clr-primary)" }} />
              <div>
                <div className="hero__vc-alert-title">Bitki Sağlığı</div>
                <div className="hero__vc-alert-sub">Tüm parseller normal</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section features">
        <div className="container">
          <div className="features__header">
            <span className="section-label">Teknoloji</span>
            <h2 className="section-title">Neden Vincora?</h2>
            <p className="section-subtitle">
              Vincora, meyve bahçelerinde üretkenliği artırmak, maliyetleri
              azaltmak ve operasyonları otonom hale getirmek için yapay zeka ve
              robotik teknolojilerini bir araya getirir. Güvenilir, veriye
              dayalı ve kolay kullanılabilir sistemler geliştiriyoruz.
            </p>
          </div>
          <div className="features__grid">
            {features.map((f, i) => (
              <FeatureCard key={i} {...f} />
            ))}
          </div>
        </div>
      </section>

      <section className="section solutions">
        <div className="container">
          <div className="solutions__header">
            <span className="section-label">Çözümlerimiz</span>
            <h2 className="section-title">Geliştirdiğimiz Sistemler</h2>
          </div>
          <div className="solutions__grid">
            {solutions.map((s, i) => (
              <SolutionCard key={i} {...s} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
